export default __webpack_public_path__ + "static/Ziadost_o_udelenie_vodicskeho_opravnenia_Autoskola_Hron_sro-18164a5e59b9d066d2716240da6d104d.pdf";